import { deleteComment } from '../../../common/store/comments/delete-comment';
import { COMMENT_DELETE } from '../../../common/components/message/message-types';

export const deleteCommentModalResolver = (payload, { showMessage }) => (dispatch) => {
  return dispatch(deleteComment(payload)).then(() => showMessage(COMMENT_DELETE));
};
